import styled from 'styled-components';

import { MAX_WIDTH } from '../../../constants';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
  margin-top: 20px;

  div {
    max-width: ${MAX_WIDTH};
  }
`;

export const SubtitleWrapper = styled.div`
  ${(props) => props.theme.typography.description};
  color: ${(props) => props.theme.colors.muted};
  text-align: center;
`;

export const NotificationWrapper = styled.div<{ marginTop: number }>`
  margin-top: ${(props) => props.marginTop}px;
  display: flex;
  justify-content: center;
  max-width: ${MAX_WIDTH};
  gap: 10px;
  flex-flow: column;

  p {
    margin-top: 32px;
  }
  div:first-child {
    text-align: left;
  }
`;
